import { Injectable } from "@angular/core";
import { of } from "rxjs";

import { IAppConfiguration } from "@logex/framework/lg-application";

import { AppSettings } from "@mrdm-self-service-frontend/shared/types";

@Injectable({
    providedIn: "root"
})
export class SharedConfigMockService {
    private static MockConfiguration: AppSettings = {
        instance: "exploration",
        environment: "test",
        version: "abcdef.000",
        api: {
            applicationUrl: "https://selfservice.test.mrdm.com/",
            authorizationUrl: "https://user-authorization-api-test.mrdm.eu/"
        },
        links: {
            supportLink: "https://support.mrdm.com/",
            myAccountLink: "https://myaccount-test.mrdm.com/"
        },
        auth0: {
            domain: "accounts-test.mrdm.io",
            clientId: "lRVgFROAGlxOS7BFMVyK7A4BSDmKBQCL",
            audience: "https://selfservice-api.mrdm.io",
            forceTicketCheck: true
        },
        matomo: {
            siteId: 79,
            organizationDimensionId: 2,
            registryDimensionId: 1
        },
        userflow: {
            environmentKey: "", // todo
            contentId: ""
        }
    };

    configuration$ = of(SharedConfigMockService.MockConfiguration);

    getConfiguration(): AppSettings | null {
        return SharedConfigMockService.MockConfiguration;
    }

    getAppConfiguration(): IAppConfiguration {
        return {
            instance: "",
            environment: "",
            applicationInsightsInstrumentationKey: "",
            logoutUrl: "",
            switchHospital: true,
            switchHospitalUrl: "",
            switchMergedHospitals: true,
            testMachine: "",
            applicationRoot: "",
            ready: Promise.resolve()
        };
    }
}
